import { isErrored, isFailed, isReceived, isRequested } from '@sonar-software/xuder';
import { useAppNotifications, useAsyncProcessing } from '@hooks';
function getNotificationOptions(options) {
    if (typeof options === 'string') {
        return {
            description: options
        };
    }
    return options;
}
function statusToAlertType(status) {
    const stateStatus = status;
    switch (true) {
        case isRequested(stateStatus):
            return 'info';
        case isErrored(stateStatus):
        case isFailed(stateStatus):
            return 'error';
        case isReceived(stateStatus):
            return 'success';
        default:
            return 'error';
    }
}
export const AsyncStateNotification = ({ byStatusCode, errored, failed, received, requested, resetRawAction, resetAction, stateSelector }) => {
    const { openNotification } = useAppNotifications();
    useAsyncProcessing({
        onReset: resetAction,
        onStatus: (status, options) => openNotification(statusToAlertType(status), options.description, options.options),
        onStatusCode: (status, options) => openNotification(statusToAlertType(status), options.description, options.options),
        resetAction: resetRawAction,
        stateSelector,
        statusCodeHandlers: byStatusCode === null || byStatusCode === void 0 ? void 0 : byStatusCode.reduce((codes, entry) => {
            codes[entry.statusCode] = entry.options;
            return codes;
        }, {}),
        statusHandlers: {
            errored: getNotificationOptions(errored),
            failed: getNotificationOptions(failed),
            received: getNotificationOptions(received),
            requested: getNotificationOptions(requested)
        },
        watchAllCalls: true
    });
    return null;
};
